import React from 'react'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...props} viewBox="-2 -2 24 24">
    <path d="M18.5 0h-17C.7 0 0 .6 0 1.4v17.2c0 .8.7 1.4 1.5 1.4h17c.8 0 1.5-.6 1.5-1.4V1.4c0-.8-.7-1.4-1.5-1.4zM3.1 16.7v-9h3v9H3zM4.6 6.5c-1 0-1.7-.7-1.7-1.6 0-.8.7-1.5 1.7-1.5s1.7.7 1.7 1.5c0 1-.7 1.6-1.7 1.6zm12.3 10.2h-3V12c0-1.2-.5-2-1.5-2-.9 0-1.4.5-1.6 1v5.8h-3v-9h3V9a3 3 0 012.6-1.5c2 0 3.5 1.3 3.5 4v5.2z" />
  </BaseIcon>
)
